
import jsPDF              from 'jspdf';
import fmt                from '@/components/mixins/fmt.js'

export default {
    mixins : [fmt],
    methods: {
    

        async printPackingList(items,headings)
        {
          
          function wait(ms) 
          {
              return new Promise(resolve => {
              setTimeout(() => { resolve('') },ms);
              })
          }
          
          let r           = 0
          let last_row    = 268
          let grandTotal1 = 0
          let grandTotal2 = 0
          
          const doc = new jsPDF()
    
          var page         = 1            
          var row_index    = 1      
          var init_row     = 80
          var row          = init_row
         
          var col          = 3
          var col1         = 17
          var col2         = 47
          var col3         = 107
          var col4         = 137
          var col5         = 177
          var col6         = 205
          
         
          const header = () =>
          {
    
          // SENDER    
          doc.setDrawColor(51,0,0)        
          doc.setFillColor(232,232,232)          
          doc.roundedRect(2, 5, 100, 25,2,2,'FD')
    
          doc.setFontSize(6)
          doc.text('Cedente'  ,5,8)
                
          if(headings.length > 0)
          {          
            doc.setFontSize(12)
            doc.setFont("helvetica", "bold")
            doc.text(headings[0].heading1  ,4,14)        
            doc.setFont("helvetica", "normal")
            doc.setFontSize(10)
            doc.text(headings[0].heading2  ,4,18)        
            doc.text(headings[0].heading3  ,4,22)        
            doc.text(headings[0].heading4  ,4,26)               
          }
          
    
          // SUPPLIER
          doc.setDrawColor(51,0,0)        
          doc.setFillColor(232,232,232) 
          doc.roundedRect(108, 5, 100, 25,2,2,'FD')
          let xCol = 110    
          doc.setFontSize(6)
          doc.text('Cessionario'  ,xCol+1,8)
          doc.setFontSize(12)
          doc.text(items[1][0].supplier  ,xCol,13)      
          doc.setFontSize(10)
          doc.text(items[1][0].address  ,xCol,17)
          doc.text(items[1][0].postalCode + ' ' +  items[1][0].city ,xCol,21)
          doc.text(items[1][0].country  ,xCol,25)
          doc.text('P.IVA ' + items[1][0].vat_number ,xCol,29)
    
          // PACKING 
          xCol = 50
          doc.setDrawColor(0,0,0)
          doc.setFillColor(0,0,0)
          doc.roundedRect(5, 32, 98, 28,2,2)    
          doc.setFontSize(12)      
          
    
          doc.text('PACKING LIST' ,7,38)
          doc.text('TOTALE QUANTITA\'' ,7,53)
    
    
          xCol = 110
          doc.roundedRect(108, 32, 100, 28,2,2)       
        
          doc.setFont('helvetica', 'italic')
          doc.setFontSize(7)
          doc.setFont("helvetica",'normal')
    
          doc.setFontSize(12)
        
          doc.setFont('helvetica', 'italic')
          doc.setFontSize(7)
          
              
          doc.setFont("helvetica",'normal')
    
          doc.setFontSize(12)
          
         
          doc.setFont('helvetica', 'italic')
          
          doc.setFontSize(8)
         
    
          doc.setFont("helvetica",'normal')
    
          doc.roundedRect(2, 70, 206, 222,1,1)  
          
          doc.line(2, 275, 208,275)
    
          doc.line(140, 292, 140, 275)
          doc.line(70, 292, 70, 275)
          doc.line(2, 270, 208,270)
    
    
          
        
    
          doc.line(2, init_row-3,208, init_row-3)
          doc.setFont("helvetica","bold");
          
            doc.setFontSize(10)
          
            doc.text('BRAND', col1,init_row -4);
            doc.text('CODICE', col2,init_row -4);
            doc.text('CATEGORIA', col3, init_row -4);
            doc.text('REPARTO', col4, init_row -4);
            doc.text("QUANTITA'", col5, init_row -4,{align:'right'});
            
            doc.text('IMPORTO', col6, init_row -4,{align:'right'});                    
            doc.setFont("helvetica","normal");
            
    
          }
          var footer = function(page,pages,total)
          {
    
          if(page == 1)
          { 
            doc.setFontSize(12)  
            doc.text(grandTotal1.toString() ,75,53)
            if(total)
            {
              doc.setFontSize(12) 
              doc.text('TOTALE EURO ' ,7,58)
              doc.text(grandTotal2.toLocaleString('it-IT',{ style: 'currency', currency: 'EUR' }) ,75,58)
            }  
          }
            
            doc.setPage(page)
            doc.roundedRect(108, 61, 100, 8,2,2)        
            doc.setFontSize(14)
            doc.text('Pagina ' + page.toString() + ' / ' + pages.toString(),  155, 67, null, null, "center");
            if(page < pages)
            {
              doc.setFontSize(14)
              doc.text('SEGUE ' , 155,285)    
              
            }
           
          }
          
          header()
    
          let j
          // MAIN LOOP
          for (j = 0; j < items[0].length; j++) {
          
          let item = items[0][j]
           
            r++  
           // this.progress = Math.round(r / items.length * 100)
            await wait(0) 
    
            grandTotal1 += item.qty
            grandTotal2 += item.total
    
            
           
            if(row > last_row )
            {
              page++  
              doc.addPage("a4");
              row = init_row
              header()
            
            }
           
           doc.setFontSize(8)
           doc.text(row_index.toString(), col, row)
           doc.setFont("helvetica","bold")
           doc.text(item.brand.toString().substr(0,15), col1, row)
           doc.text(item.sku.toString().substr(0,30), col2, row)
           
           doc.text(item.category.toString().substr(0,50), col3, row) 
           doc.text(item.department.toString().substr(0,15), col4, row)       
           doc.text(item.qty.toString().substr(0,25), col5, row,{align:'right'})
           
           
           doc.text(this.fmt1(item.total.toString().substr(0,25),2), col6, row,{align:'right'})
                   
           doc.setFont("helvetica","normal")
    
           row_index++ 
           row = row + 5
    
           if(row > last_row )
            {
              page++  
              doc.addPage("a4");
              header()
              row = init_row
    
             
            }
    
           let n    = col + 18
           let w    = 11.8 
           let cols =  JSON.parse(item.header)
           
           // HEADER COLS
           cols.forEach(col => {  
            doc.setFontSize(8) 
            doc.setFillColor(240,240,240)  
            
            doc.rect(n -1, row -3, w, 4,'FD');
            
            doc.text(col.size.toString().substr(0,6) , n, row);  
            n= n + w
           })
           
           let colors = JSON.parse(item.data)
           
           row = row + 5
           colors.forEach(color => {
           
            if(row > last_row )
            {
              page++  
              doc.addPage("a4")
              row = init_row + 1
              header()
               
            }
    
            // COLOR
            doc.setFontSize(8)
            if(color.color)
            {
              doc.text(color.color.toString().substr(0,9) , 5, row )
            }
            else
            {
              doc.text('MANCANTE' , 5, row )
            }
            
            let sizes  = color.s
            n = col + 18
    
            // SIZES
            cols.forEach(col =>{
              sizes.forEach(size=>{
                doc.setDrawColor(200,200,200)       
                doc.rect(n -1, row -3, w, 4)
                doc.setDrawColor(0)       
                if(col.size == size.size) 
                { 
                  doc.text(size.qty.toString().substr(0,10) , n, row )
                } 
    
              })
              n = n + w 
            })
                      
            row = row + 4
           
           })
    
           row = row + 4
            
          }
          
          doc.setFontSize(10)
          
          doc.setPage(1)
    
        
          for (let i = 1; i <= page  ; i++) 
            {
              footer(i,page,'total')
           }
    
          //this.progress = 0
          let fileName = 'CheckList_' + Date.now().toString()
          window.open(doc.output('bloburl', { filename: fileName }), '_blank');
          
        },
    
       
      


        }
  }
